import type { CanvasActionInput } from '@hector/shared-types';

/**
 * Contrat local entre les étapes sémantiques sûres du modèle et les opérations
 * du moteur de plans natif SuperDoc.
 *
 * Source : https://docs.superdoc.dev/document-api/mutation-plans/
 * (contrat public vérifié le 2026-09-19). Le modèle ne reçoit jamais les
 * identifiants d'opérations du fournisseur : cette table est la frontière qui
 * les compile depuis les étapes Hector.
 */
export const EDIT_PLAN_OPERATION_BY_STEP = {
  assert_text: 'assert',
  text_rewrite: 'text.rewrite',
  text_insert: 'text.insert',
  text_delete: 'text.delete',
  format_apply: 'format.apply',
} as const;

export type EditPlanStepName = Extract<CanvasActionInput, { action: 'apply_edit_plan' }>['steps'][number]['op'];
export type NativeEditPlanOperation = typeof EDIT_PLAN_OPERATION_BY_STEP[EditPlanStepName];

/** Toutes les opérations que `planEngine.supportedStepOps` doit publier. */
export const ETAPES_PLAN_NATIVES_REQUISES: readonly NativeEditPlanOperation[] = Object.values(EDIT_PLAN_OPERATION_BY_STEP);
